
class PrintHistoryController {
    static $inject = ['$translate', '$scope'];

    constructor($translate, $scope) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.model = {
            history: []
        }
    }

    $onInit() {
        this.model.history = window.opener.w.printData;
        this.print()
    }

    print() {
        setTimeout(() => {
            window.print();
        }, 500)
    }

    convertArrayToObject(arr) {
        arr = arr.filter(e => e.value != 'null')
        const result = {};
        for (const item of arr) {
            result[item.key] = item.value;
        }
        return result;
    }

    flexibleObjectParser(input) {
        // Helper function to check if a string is valid JSON
        function isJSON(str) {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        }
    
        // Helper function to parse JSON safely
        function safeJSONParse(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return str;
            }
        }
    
        // Main parsing logic
        function parseValue(value) {
            if (typeof value === 'string' && isJSON(value)) {
                return parseValue(safeJSONParse(value));
            } else if (Array.isArray(value)) {
                return value.map(parseValue);
            } else if (typeof value === 'object' && value !== null) {
                const result = {};
                for (const [key, val] of Object.entries(value)) {
                    result[key] = parseValue(val);
                }
                return result;
            } else {
                return value;
            }
        }
    
        // Start the parsing process
        return this.convertArrayToObject(parseValue(input));
    }

    translateEntryType(type){
        return this.$translate.instant('entry_type.'+type)
    }
}

export default PrintHistoryController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/edit/print/print_history.controller.js